import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBancontactComponent } from './simple-icons-bancontact.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBancontactComponent ],
    exports:      [ SimpleIconsBancontactComponent ],
    bootstrap:    []
})
export class SimpleIconsBancontactModule {}
